import {flow, get, toGrams, toNumber} from '@yandex-delivery/utils'
import type {ParcelDimensions} from 'src/shared/types'

type GetFunction = (size?: ParcelDimensions) => number

export const getLength: GetFunction = flow(get('length'), toNumber)
export const getHeight: GetFunction = flow(get('height'), toNumber)
export const getWidth: GetFunction = flow(get('width'), toNumber)
export const toWeight: (weight?: number) => number = flow(
  toNumber,
  toGrams,
  Math.round,
)
export const getWeightGross: GetFunction = flow(get('weight'), toWeight)
